import { Heading, List, Paragraph } from '@zillow/constellation-10';
import type { CreditReportTypeWithStatement } from '@zg-rentals/applications-utils';

export function CreditReportStatements({ creditReport }: { creditReport: CreditReportTypeWithStatement }) {
  const statements = creditReport.fullCreditProfile?.Statement;
  return statements && statements.length > 0 ? (
    <>
      <Heading level={3} textStyle="heading-xs" css={{ marginTop: 'md' }}>
        General or consumer statements
      </Heading>

      <List.Root>
        {statements.map((statement) => (
          <List.Item key={statement.StatementText}>
            <Paragraph textStyle="body-sm-bold">Date reported {statement.DateReported}</Paragraph>
            <Paragraph textStyle="body-xs">{statement.StatementText}</Paragraph>
          </List.Item>
        ))}
      </List.Root>
    </>
  ) : null;
}
